import { createApp } from "vue";
import { createPinia } from "pinia";
import naive from "naive-ui";

import App from "./App.vue";
import router from "./router";
import Directive from "./directive/index.js";

import "./assets/css/default.css";
import "./assets/css/iconfont.css";
import "@/assets/css/share/share.scss";

const app = createApp(App);

app.use(createPinia());
app.use(router).use(Directive).use(naive);

app.mount("#app");
